'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _yup = require('yup');

var yup = _interopRequireWildcard(_yup);

var _Logger = require('./Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _Sleeper = require('./Sleeper');

var _Sleeper2 = _interopRequireDefault(_Sleeper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var schema = yup.object({
    name: yup.string().required("RetryContext missing name to indicate what context retries are happening in"),
    maxRetries: yup.number().required("RetryContext missing maxRetries setting"),
    retryNullResults: yup.bool(), //defaults to false
    pauseBetweenTries: yup.number() //defaults to 500ms
});

var log = new _Logger2.default({ component: "RetryContext" });

/**
 * RetryContext class handles retrying a function call until results are provided. It can be
 * configured with max number of retry attempts, whether to retry if null results are returned
 * from function, and how long to pause between retries. It can also be given an optional
 * 'continuationFilter' function that will be called with errors and if that function
 * returns false, the retries will end immediately with the last error.
 */

var RetryContext = function () {
    function RetryContext(props) {
        var _this = this;

        _classCallCheck(this, RetryContext);

        schema.validateSync(props);
        this.name = props.name;
        this.maxRetries = props.maxRetries;
        this.retryNullResults = props.retryNullResults || false;
        this.pauseBetweenTries = props.pauseBetweenTries || 500;

        //optionally, a continuation function can be called to determine 
        //if we should keep going if an error occurs.
        this.continuationFilter = props.continuationFilter;

        ['invoke', '_invokeWithRetries'].forEach(function (fn) {
            return _this[fn] = _this[fn].bind(_this);
        });
    }

    /**
     * Invoke the given function with the args provided and callback with results. This 
     * will keep invoking with a pause between errors over maxRetries attempts.
     * 
     * @param {function to invoke} fn 
     * @param {callback with error or results (e, r)} cb 
     * @param  {fn args} args 
     */


    _createClass(RetryContext, [{
        key: 'invoke',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(fn, cb) {
                for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                    args[_key - 2] = arguments[_key];
                }

                var ctx, r;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                ctx = {
                                    tries: 0,
                                    fn: fn,
                                    args: args
                                };
                                _context.prev = 1;
                                _context.next = 4;
                                return this._invokeWithRetries(ctx);

                            case 4:
                                r = _context.sent;
                                _context.next = 7;
                                return cb(null, r);

                            case 7:
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](1);
                                return _context.abrupt('return', cb(_context.t0));

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[1, 9]]);
            }));

            function invoke(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return invoke;
        }()

        //internal loop to keep retrying until results are retrieved.

    }, {
        key: '_invokeWithRetries',
        value: function _invokeWithRetries(ctx) {
            var _this2 = this;

            return new Promise(function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(done, err) {
                    var r, check;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    if (!(ctx.tries < _this2.maxRetries)) {
                                        _context2.next = 37;
                                        break;
                                    }

                                    ++ctx.tries;
                                    _context2.prev = 2;
                                    _context2.next = 5;
                                    return ctx.fn.apply(ctx, _toConsumableArray(ctx.args));

                                case 5:
                                    r = _context2.sent;

                                    if (!(!r && _this2.retryNullResults)) {
                                        _context2.next = 12;
                                        break;
                                    }

                                    log.debug("No result in retry context", _this2.name, "Pausing and trying again...");
                                    _context2.next = 10;
                                    return (0, _Sleeper2.default)(_this2.pauseBetweenTries);

                                case 10:
                                    _context2.next = 13;
                                    break;

                                case 12:
                                    return _context2.abrupt('return', done(r));

                                case 13:
                                    _context2.next = 35;
                                    break;

                                case 15:
                                    _context2.prev = 15;
                                    _context2.t0 = _context2['catch'](2);

                                    if (!(typeof _this2.continuationFilter === 'function')) {
                                        _context2.next = 29;
                                        break;
                                    }

                                    _context2.prev = 18;
                                    _context2.next = 21;
                                    return _this2.continuationFilter(_context2.t0);

                                case 21:
                                    check = _context2.sent;

                                    if (!(typeof check !== 'undefined' && !check)) {
                                        _context2.next = 24;
                                        break;
                                    }

                                    return _context2.abrupt('return', err(_context2.t0));

                                case 24:
                                    _context2.next = 29;
                                    break;

                                case 26:
                                    _context2.prev = 26;
                                    _context2.t1 = _context2['catch'](18);

                                    log.error("Problem querying continuation filter fn", _context2.t1);

                                case 29:
                                    log.debug("Getting error in retry context", _this2.name, _context2.t0);

                                    if (!(ctx.tries >= _this2.maxRetries)) {
                                        _context2.next = 33;
                                        break;
                                    }

                                    log.error("Giving up invoking fn in retry context", _this2.name, _context2.t0);
                                    return _context2.abrupt('return', err(_context2.t0));

                                case 33:
                                    _context2.next = 35;
                                    return (0, _Sleeper2.default)(_this2.pauseBetweenTries);

                                case 35:
                                    _context2.next = 0;
                                    break;

                                case 37:
                                    err(new Error("Could not complete retry context", _this2.name, "after", _this2.maxRetries, "tries"));

                                case 38:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this2, [[2, 15], [18, 26]]);
                }));

                return function (_x3, _x4) {
                    return _ref2.apply(this, arguments);
                };
            }());
        }
    }]);

    return RetryContext;
}();

exports.default = RetryContext;